import classNames from 'classnames';
import React from 'react';
import type { HtmlString } from '~/Features/Types/HtmlString.csharp';
import { HtmlDiv } from '~/Partials/Controls/HtmlDiv';
import { HtmlHeading } from '~/Partials/Controls/HtmlHeading';
import styles from './Testimony.module.css';
import type { TestimonyVariant } from './TestimonyVariant';

export interface TestimonyProps {
    heading?: HtmlString;
    content?: HtmlString;
    variant?: TestimonyVariant;
}

export const Testimony: React.FC<TestimonyProps> = props => {
    const { heading, content, variant = 'light' } = props;

    return (
        <div className={styles[`Variant--${variant}`]}>
            <div className={styles.Inner}>
                {heading && <HtmlHeading type="h3" html={heading} className={styles.Heading} />}
                {content && (
                    <HtmlDiv
                        className={classNames(styles.Content, 'RichtextContent', `RichtextContent--${variant}`)}
                        html={content}
                    />
                )}
            </div>
        </div>
    );
};
